import React from 'react';
import { Undo2 } from 'lucide-react';

interface ExitShareViewButtonProps {
  onExit: () => void;
  isMobile: boolean;
  isUnified?: boolean; // Controls whether button is rectangular (unified with date pill) or circular
  isAnimatingOut?: boolean; // Controls exit animation
}

const ExitShareViewButton: React.FC<ExitShareViewButtonProps> = ({
  onExit,
  isMobile,
  isUnified = false,
  isAnimatingOut = false,
}) => {
  const buttonSize = isMobile ? 44 : 52;

  // When unified, button should be rectangular and match date pill height
  const unifiedHeight = isMobile ? 40 : 44; // Approximate height of date pill
  const unifiedWidth = isMobile ? 44 : 52;

  return (
    <div
      className="exit-share-view-button-container"
      style={{
        position: isUnified ? 'relative' : 'fixed',
        zIndex: isUnified ? 'auto' : 9996,
        right: isUnified ? 'auto' : isMobile ? '12px' : '20px',
        top: isUnified ? 'auto' : '20%',
        transform: isUnified
          ? isAnimatingOut
            ? 'translateX(100px)'
            : 'none' // Slide right when animating
          : 'translateY(-50%)',
        display: 'flex',
        alignItems: 'stretch',
        opacity: isAnimatingOut ? 0 : 1, // Fade out when animating
        transition: 'all 400ms ease-out', // Smooth transition for both slide and fade
      }}
    >
      <button
        data-testid="exit-share-view-button"
        onClick={onExit}
        onTouchEnd={onExit}
        className="exit-share-view-button"
        style={{
          width: isUnified ? unifiedWidth : buttonSize,
          height: isUnified ? unifiedHeight : buttonSize,
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(65, 100, 81, 1)',
          borderRadius: isUnified ? '12px' : '50%',
          borderBlockColor: 'rgba(22, 22, 21, 1)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
          transition: 'all 0.2s ease',
          position: 'relative',
        }}
      >
        {/* Icon container with two icons for visual clarity */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          <Undo2 size={22} color="white" strokeWidth={2.5} />
        </div>
      </button>
    </div>
  );
};

export default ExitShareViewButton;
